import { type ReactNode } from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import { Form } from 'react-bootstrap';
import { FormProvider, useForm } from 'react-hook-form';

import { configHookForm } from './config';

type HookFormValidationMode = 'onBlur' | 'onChange' | 'onSubmit' | 'onTouched' | 'all';

export interface HookFormProps {
  onSubmit?: (data: any, reset?: any) => void;
  validations?: any;
  children?: ReactNode;
  initialValues?: any;
  nameForm?: string;
  validationMode?: HookFormValidationMode;
}

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

function HookForm(props: HookFormProps) {
  const methods = useForm({
    resolver: props.validations ? (yupResolver(props.validations) as any) : undefined,
    defaultValues: props.initialValues ? props.initialValues : {},
    mode: props.validationMode ? props.validationMode : 'onChange'
  });

  const { formState } = methods;

  const submit = async (data: any) => {
    if (props.onSubmit) {
      props.onSubmit(data);
      await sleep(configHookForm.submitDelay);
    }
  };

  return (
    <FormProvider {...methods}>
      <Form
        noValidate
        autoComplete="off"
        id={props.nameForm}
        onSubmit={
          formState.isSubmitting
            ? (e) => {
                e.preventDefault();
              }
            : methods.handleSubmit((data) => submit(data))
        }>
        {props.children}
      </Form>
    </FormProvider>
  );
}

export default HookForm;
